import { createContext, useContext, useState, type ReactNode } from 'react';
import { disableDemoMode, enableDemoMode, isDemoModeEnabled } from '../lib/demoMode';

// Estado React em volta de demoMode.ts (localStorage) — só pra que
// ligar/desligar o modo de demonstração atualize a tela na hora (Gates em
// App.tsx e o botão "Sair" do Layout), sem precisar recarregar a página.
// Nunca ativa fora de `npm run dev` (ver demoMode.ts).

interface DemoModeState {
  enabled: boolean;
  enable: () => void;
  disable: () => void;
}

const DemoModeContext = createContext<DemoModeState | undefined>(undefined);

export function DemoModeProvider({ children }: { children: ReactNode }) {
  const [enabled, setEnabled] = useState(isDemoModeEnabled);

  const value: DemoModeState = {
    enabled,
    enable: () => {
      enableDemoMode();
      setEnabled(true);
    },
    disable: () => {
      disableDemoMode();
      setEnabled(false);
    },
  };

  return <DemoModeContext.Provider value={value}>{children}</DemoModeContext.Provider>;
}

export function useDemoMode(): DemoModeState {
  const context = useContext(DemoModeContext);
  if (!context) {
    throw new Error('useDemoMode must be used within a DemoModeProvider');
  }
  return context;
}
